import { Table } from 'antd'
import styled from 'styled-components'

export const DrawerBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const HeaderInfo = styled.div`
  margin-bottom: 16px;
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
`

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.span`
  font-size: 12px;
  color: #666;
`

export const SectionTitle = styled.h3`
  margin-top: 20px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 12px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`

/* Technician log */

export const LogSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const LogEntry = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
`

export const LogAvatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #1677ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
`

export const LogBubble = styled.div`
  background: #f5f7fa;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  padding: 10px 14px;
  flex: 1;
  word-break: break-word;
`

export const LogTimestamp = styled.div`
  font-size: 11px;
  color: #999;
  margin-bottom: 4px;
`

export const LogText = styled.div`
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;
  line-height: 1.5;
`

export const AddLogSection = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Footer = styled.div`
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  margin-top: 12px;
`

/* Pending list modal */

export const PendingTable = styled(Table)`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 10px;
  }

  .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
  }
`

export const ModalHeader = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
